import { useState } from "react";
import { FileInput, ImageField, ImageInput } from "react-admin";
import { useFormContext } from "react-hook-form";

const UploadVideo = ({ name, label, record }) => {
  const form = useFormContext();
  const [videoUrl, setVideoUrl] = useState("");
  const upload = async (e) => {
    var formData = new FormData();
    formData.append("image", e);
    const reponse = await fetch(
      // `http://localhost:3060` + "/image/upload",
      `https://api.mahsool.sd` + "/image/upload",
      {
        method: "POST",
        body: formData,
      }
    ).then((res) => res.json());
    setVideoUrl(reponse.url);
    form.setValue(
      `${name}`,
      record ? [...record.video, reponse.url] : reponse.url
    );
  };
  //
  return (
    <>
      {!videoUrl ? (
        ""
      ) : (
        <div className="flex justify-center">
          <video controls src={videoUrl} className="w-[40rem]"></video>
        </div>
      )}
      <FileInput
        source={`video`}
        onChange={(e) => upload(e)}
        multiple={false}
        accept=".mp4, .avi, .mov, .wmv, .mkv"
      ></FileInput>
    </>
  );
};

export default UploadVideo;
